import React from "react";
import { Grid, Card } from "@mui/material";
import TaxFilingStatusUponDeath from "@instream-solutions/instream-design-system/lib/Components/TaxFilingStatusUponDeath/TaxFilingStatusUponDeath";

const TaxFilingStatusUponDeathStep = (props) => {
  return (
    <Grid
      container
      id="insurance-tab"
      className="tab-container tax-status-upon-death"
      direction="row"
      md={9}
      spacing={6}
    >
      <Grid item xs={12}>
        <Card className="card">
          <TaxFilingStatusUponDeath {...props} />
        </Card>
      </Grid>
    </Grid>
  );
};

export default TaxFilingStatusUponDeathStep;
